import axios from "axios";
import {API_URL_ESPACE_COMMON_CANDIDAT_PREEMBAUCHE} from "../../../../constants";
import {CandidatureModel} from "../../../../models";


export function getCandidatures() {
    return axios.get<CandidatureModel[]>(`${API_URL_ESPACE_COMMON_CANDIDAT_PREEMBAUCHE}/candidatures`)
}
